import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../../../css/payment-dropdown.css';
import { Collapse } from 'react-collapse';

class PaymentDropdown extends Component {
	toggleDropdown = () => {
		this.props.setActive();
	};

	render() {
		const { title, description, images, active, children } = this.props;
		return (
			<React.Fragment>
				<div
					className={`payment-dropdown ${active ? 'open' : ''}`}
					onClick={() => this.toggleDropdown()}
				>
					<div className="payment-dropdown-title">
						<input type="radio" name="payment" checked={active} readOnly />
						{title}
					</div>
					<div className="payment-dropdown-images">
						{images.map((img, index) => (
							<img
								style={{ height: '34px' }}
								key={index}
								src={require(`../../../images/payment-methods/${img}`)}
								alt=""
							/>
						))}
					</div>
				</div>
				<Collapse isOpened={this.props.active}>
					{description && <div className="payment-dropdown-desc">{description}</div>}
					<div className="payment-dropdown-children">{children}</div>
				</Collapse>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		store: state,
	};
};

export default connect(
	mapStateToProps,
	{}
)(PaymentDropdown);



// WEBPACK FOOTER //
// ./src/components/checkout/payment/PaymentDropdown.js